"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.FeedbackButton = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var button_1 = __importDefault(require("@atlaskit/button"));
var feedback_1 = __importDefault(require("@atlaskit/icon/glyph/feedback"));
var trello_1 = require("@powerupsclub/trello");
var react_1 = require("react");
var FeedbackButton = function (_a) {
    var hideText = _a.hideText, feedbackPath = _a.feedbackPath, compact = _a.compact;
    var trelloIframe = (0, react_1.useContext)(trello_1.TrelloPowerUpContext).trelloIframe;
    var onClickHandler = (0, react_1.useCallback)(function (e) {
        trelloIframe.popup({
            title: trelloIframe.localizeKey('Give us feedback'),
            url: feedbackPath !== null && feedbackPath !== void 0 ? feedbackPath : './feedback',
            height: 350,
            mouseEvent: e
        });
    }, []);
    return ((0, jsx_runtime_1.jsx)(button_1["default"], __assign({ appearance: compact ? 'subtle-link' : undefined, spacing: compact ? 'compact' : 'default', iconBefore: (0, jsx_runtime_1.jsx)(feedback_1["default"], { label: "give us feedback" }, void 0), onClick: onClickHandler }, { children: !hideText && trelloIframe.localizeKey('Give us feedback') }), void 0));
};
exports.FeedbackButton = FeedbackButton;
//# sourceMappingURL=FeedbackButton.js.map